import React from "react";
import { Box, Button, Container } from "@mui/material";

const Invoice = () => {
  const screenshotUrl = "/invoice.png";
  const downloadFile = "/RedefinedInvoice.xlsx";

  const downloadTransactions = () => {
    const link = document.createElement("a");
    link.href = downloadFile;
    link.download = "RedefinedInvoice.xlsx";
    link.click();
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        minHeight: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxHeight: "calc(95vh - 100px)",
          overflowY: "auto",
          backgroundColor: "#fff",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <Button onClick={downloadTransactions} variant="contained">
            Download Transactions
          </Button>
        </Box>

        <img
          src={screenshotUrl}
          alt="Invoice Screenshot"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </Box>
    </Container>
  );
};

export default Invoice;
